import { useEffect, useState } from "react";

import { View } from "./View";

interface RootPinCodeInputProps {
  pin: string;
  pinCodeLength: number | null;
  title: string;
  subtitle: string;
  buttonText?: string;
  errorMessage?: string | null;
  showPinValues?: boolean;
  // submitting
  handlePinSubmit: () => void;
}

export interface IPinCodeInputProps extends RootPinCodeInputProps {
  onChange: (pin: string) => void; // true if the pin is valid
}

export interface IPinCodeInputViewProps extends RootPinCodeInputProps {
  pinInputErrorMessage?: string | null;

  handlePinInput: (inputValue: string) => void;
  handlePinDelete: () => void;
}

export function PinCodeInput(props: IPinCodeInputProps) {
  const { pin, pinCodeLength, errorMessage, onChange, handlePinSubmit } = props;

  useEffect(() => {
    if (pin.length === pinCodeLength) {
      // alert("Auto-submitting PIN");
      handlePinSubmit();
    }
  }, [pin, pinCodeLength]);

  const handlePinInput = (inputValue: string) => {
    if (!pinCodeLength || pin.length < pinCodeLength) {
      onChange(pin + inputValue);
    }
  };

  const handlePinDelete = () => {
    if (pin.length > 0) {
      onChange(pin.substring(0, pin.length - 1));
    }
  };

  return (
    <View
      title={props.title}
      subtitle={props.subtitle}
      buttonText={props.buttonText}
      pin={pin}
      pinCodeLength={pinCodeLength}
      pinInputErrorMessage={errorMessage}
      showPinValues={props.showPinValues}
      handlePinInput={handlePinInput}
      handlePinDelete={handlePinDelete}
      handlePinSubmit={props.handlePinSubmit}
    />
  );
}
